import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ServiceAppointmentDeclinedOperationsEntityEffects } from './service-appointment-declined-operations.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([ServiceAppointmentDeclinedOperationsEntityEffects])]
})
export class ServiceAppointmentDeclinedOperationsEntityModule {}
